import React, { useRef } from 'react';
import ModalWrapper from '../../ModalWrapper';
import CommonFooter from '../../FormComponent/CommonFooter';
import { FormSchemas, FormWrapper } from '../../FormComponent';
import { DO_NOTHING } from '../../../utils/commonfunctions';

export default function AddUpdateEnvironmentPopup({ closePopup=DO_NOTHING, handleEnvironmentAdd=DO_NOTHING, handleEnvironmentUpdate=DO_NOTHING, initialValues={}, type="add" }) {
    const formRef = useRef(null);
    
    const handleConfirmAction = (data) => {
        const environmentName = data.environmentName;
        const environmentDescription = data.environmentDescription;
        if (environmentName) {
            if (type === "add") {
                handleEnvironmentAdd(data);
            } else {
                handleEnvironmentUpdate({
                    ...data,
                    id: initialValues?.id,
                });
            }
            closePopup();
        }
    };

    const handleFormSubmit = async () => {
        if (formRef.current) await formRef.current.submit();
    };

    const buttons = [
        {
            label: 'Cancel',
            variant: 'outline',
            className: 'primary',
            onClick: closePopup,
        },
        {
            label: type === "add" ? "Add" : "Update",
            variant: 'primary',
            className: 'white bg-blue600',
            onClick: handleFormSubmit,
        },
    ];

    const fields = [
        {
            name: 'environmentName',
            type: 'text',
            label: 'Environment Name',
            placeholder: 'Enter environment name',
            required: true,
        },
        {
            name: 'environmentDescription',
            type: 'text',
            label: 'Environment Description',
            placeholder: 'Enter environment description',
            multiline: true,
            rows: 3
        },
    ];

    return (
        <ModalWrapper
            isOpen={true}
            onClose={closePopup}
            title={type === "add" ? "Add New Environment" : "Edit Environment"}
            size="small"
            footer={
                <CommonFooter
                    buttons={buttons}
                    align="right"
                />
            }
            children={
                <FormWrapper
                    ref={formRef}
                    schema={FormSchemas.environmentForm}
                    fields={fields}
                    onSubmit={handleConfirmAction}
                    defaultValues={{
                        environmentName: initialValues?.environmentName || '',
                        environmentDescription: initialValues?.environmentDescription || ''
                    }}
                />
            }
        />
    );
}